import React, {
    createContext,
    useState,
    useContext,
    ReactNode,
  } from 'react'
  import { StreamStatus } from '../_types/stream-status.type'
  
  interface StreamStatusContextType {
    streamStatus: StreamStatus
    setStreamStatus: (status: StreamStatus) => void
  }
  
  const defaultStatus: StreamStatus = { state: 'INACTIVE' }
  
  const StreamStatusContext = createContext<StreamStatusContextType>({
    streamStatus: defaultStatus,
    setStreamStatus: () => {},
  })
  
  export const useStreamStatus = () => useContext(StreamStatusContext)
  
  interface ProviderProps {
    children: ReactNode
  }
  export const StreamStatusProvider = ({ children }: ProviderProps) => {
    const [streamStatus, setStreamStatus] =
      useState<StreamStatus>(defaultStatus)
  
    return (
      <StreamStatusContext.Provider
        value={{ streamStatus, setStreamStatus }}
      >
        {children}
      </StreamStatusContext.Provider>
    )
  }
  